import { useState, useEffect, useRef } from "react";
import Logo from "../../assets/img/logo.png";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { axiosReq, axiosReq2 } from "../../commons/axiosReq";
import Cookies from 'universal-cookie';
import VoiceIcon from "../../assets/icon/VoiceIcon";
import ActiveVoiceIcon from "../../assets/icon/ActiveVoiceIcon";
import AudioWave from "../../assets/img/wave.png";
import { useLocation } from "react-router-dom";
import { apiAssetSar, apiUrlSar } from "../../commons/inFormTypes";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";
import { Link, useNavigate, useParams } from "react-router-dom";

const MainPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [accumulatedResponse, setAccumulatedResponse] = useState("");
  const chatRef = useRef(null);
  const location = useLocation();
  const cookies = new Cookies();

  const sendMessage = async () => {
    if (message.trim() === "" || isLoading) return;

    setIsLoading(true);
    setAccumulatedResponse("");

    const userMessage = { content: message, role: "user" };
    setMessages((prev) => [...prev, userMessage]);
    setMessage("");

    var ids = cookies.get('userConnectId');
    try {
      addLog("user:" + userMessage.content.toString());

      const response = await fetch(apiUrlSar + "user/chat", {
        method: "POST",
        headers: {
          Authorization: `Bearer c2dffe2aa00a3f8b7d854279f4aaa1ff`,
          "Content-Type": "application/json",
          'X-Frame-Options': 'Deny',
          'X-Content-Type-Options': "nosniff",
          'X-XSS-Protection': "1; mode=block",
          "Referrer-Policy": "same-origin",
          "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
        },
        body: JSON.stringify({
          llm_type: location.state.type,
          user_id: ids,
          session_id: location.state.id,
          rag_system_id: location.state.ragId,
          user_prompt: userMessage.content,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let assistantMessage = { content: "", role: "assistant" };
      let inThinkingBlock = false;

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value);
        const lines = chunk
          .split('\n')
          .filter((line) => line.trim() !== '');

        for (const line of lines) {
          try {
            const parsed = JSON.parse(line);
            if (parsed?.token) {
              const content = parsed.token;

              if (content.includes('<think>')) {
                inThinkingBlock = true;
                continue;
              }
              if (content.includes('</think>')) {
                inThinkingBlock = false;
                continue;
              }
              if (!inThinkingBlock) {
                assistantMessage.content += content;
                setAccumulatedResponse((prev) => prev + content);
              }
            }
          } catch (e) {
            console.error('Error parsing JSON:', e);
          }
        }
      }

      assistantMessage.content = assistantMessage.content
        .replace(/<think>.*?<\/think>/gs, '')
        .trim();

      setMessages((prev) => [...prev, assistantMessage]);
    } catch (error) {
      console.error("Error:", error);
      setMessages((prev) => [
        ...prev,
        { content: "متاسفانه ارتباط برقرار نشد. لطفاً دوباره تلاش کنید.", role: "assistant" },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages, accumulatedResponse]);

  const addLog = async (description) => {
    try {
      const dataUser = await axiosReq("user/InsertUserLog", "post", {
        Description: description,
      });

      if (![200, 201, 204].includes(dataUser?.status)) {
        console.error("Logging failed:", dataUser);
      }
    } catch (error) {
      console.error("Error logging:", error);
    }
  };

  const GetData = async () => {
    try {
      var ids = cookies.get('userConnectId');
      const dataUser = await axiosReq2("user/chat/history", "post", {
        user_id: ids,
        session_id: location.state.id,
      });

      if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
        var mes = [];
        dataUser?.data?.map((item) => {
          mes.push({ content: item.content, role: item.type == "human" ? "user" : "assistant" });
        });
        setMessages(mes);
      }
    } catch (error) {
      console.error("Error logging:", error);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-backGray p-4 " dir="rtl">
        {/* <Link onClick={()=>window.lo} className="flex items-center justify-end font-IRANYekanBold mb-2 text-[#265069]">
       بازگشت
        </Link> */}
      <div className="bg-white rounded-3xl shadow-lg p-6 sm:p-8 w-[80%] min-h-[80vh] flex flex-col" id="chatBack">

        {/* Optional compact header */}
        {/* <div className="flex items-center gap-3 mb-4">
          <div className="w-[44px] h-[44px] bg-[#fff7e6] rounded-full flex items-center justify-center shadow-sm">
          </div>
          <span className="font-IRANYekanExtra text-[#111] text-[15px]">دستیار هوشمند</span>
        </div> */}

        {/* Messages list */}
        <div ref={chatRef} className="w-full flex-1 overflow-y-auto p-2 sm:p-4 space-y-3">
          {/* Welcome bubble */}
                      <div  className={"flex  justify-end"}>

  <div
                className={`max-w-[75%] px-4 py-2 text-sm font-IRANYekanMedium ${
                 "bg-lightGray text-gray-700 rounded-tl-xl rounded-bl-xl rounded-tr-xl rounded-br-sm"
                }`}
              >            <p>سلام! چطور می‌تونم کمکتون کنم؟</p>
          </div>
          </div>

          {/* Messages */}
          {messages.map((msg, index) => (
            <div key={index} className={`flex ${msg.role === "user" ? "justify-start" : "justify-end"}`}>
              <div
                className={`max-w-[75%] px-4 py-2 text-sm font-IRANYekanMedium ${
                  msg.role === "user"
                    ? "bg-cb text-blue-800 rounded-tr-xl rounded-tl-xl rounded-br-xl rounded-bl-sm"
                    : "bg-lightGray text-gray-700 rounded-tl-xl rounded-bl-xl rounded-tr-xl rounded-br-sm"
                }`}
              >
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeSanitize]}
                  components={{ p: ({ node, ...props }) => <p className="whitespace-pre-wrap" {...props} /> }}
                >
                  {msg.content}
                </ReactMarkdown>
              </div>
            </div>
          ))}

          {/* Streaming / loading bubble */}
          {isLoading && (
            <div className="flex justify-end">
              <div className="max-w-[75%] px-4 py-2 text-sm font-IRANYekanMedium bg-cg text-gray-700 rounded-tl-xl rounded-bl-xl rounded-tr-xl rounded-br-sm">
                <div className="whitespace-pre-wrap">{accumulatedResponse}</div>
                <div className="mt-2 w-full flex">
                  <ClipLoader color={'#2E3F59'} loading={isLoading} size={20} aria-label="loading spinner" />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Input row */}
        <div className="w-full mt-4 flex items-center gap-2">
          <input
            className="font-IRANYekanMedium flex-1 border border-[#0b94ca] rounded-full px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#0b94ca]"
            type="text"
            placeholder="پیام خود را بنویسید ..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            disabled={isLoading}
          />
          <button
            className="bg-[#0b94ca] p-2 rounded-full text-white hover:bg-[#087cad] disabled:opacity-50"
            onClick={sendMessage}
            disabled={isLoading}
            title="ارسال"
          >
            <svg width="22" height="22" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.0613 2.67905C25.1616 2.27899 25.145 1.85855 25.0135 1.46765C24.8819 1.07674 24.641 0.731798 24.3192 0.473773C23.9974 0.215748 23.6084 0.0554825 23.1982 0.0120067C22.7881 -0.0314691 22.3741 0.0436715 22.0054 0.228506L1.19275 10.6348C0.834394 10.8136 0.532959 11.0888 0.322271 11.4294C0.111582 11.77 -2.67029e-05 12.1625 -2.67029e-05 12.563C-2.67029e-05 12.9635 0.111582 13.3561 0.322271 13.6966C0.532959 14.0372 0.834394 14.3124 1.19275 14.4912L22.0054 24.8975C22.3741 25.0823 22.7881 25.1575 23.1982 25.114C23.6084 25.0705 23.9974 24.9103 24.3192 24.6522C24.641 24.3942 24.8819 24.0493 25.0135 23.6584C25.145 23.2675 25.1616 22.847 25.0613 22.447L22.8818 13.7316L10.226 12.563L22.8818 11.3944L25.0613 2.67905Z"
                fill="#fff"
              />
            </svg>
          </button>
        </div>

        <style jsx>{`
          .bg-cb { background-color: #dfe9ff; }
          .bg-cg { background-color: #f3f3f3; }
        `}</style>
      </div>
    </div>
  );
};

export default MainPage;
